module.exports = __webpack_public_path__ + "static/media/01_a_photo.37c943fe.jpg";